/** Plain text from memo body (HTML or legacy plain). */
export function memoBodyPlainText(body: string): string {
  const raw = String(body ?? '');
  if (!raw.trim()) return '';
  if (!/<[a-z][\s\S]*>/i.test(raw)) {
    return raw.replace(/\r\n/g, '\n');
  }
  if (typeof DOMParser === 'undefined') {
    return raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const doc = new DOMParser().parseFromString(wrapHtmlFragment(raw), 'text/html');
  return (doc.body.textContent ?? '').replace(/\u00a0/g, ' ').trim();
}

export function isMemoBodyEmpty(body: string): boolean {
  return !memoBodyPlainText(body);
}

/** TipTap-friendly HTML; plain text becomes paragraphs. */
export function normalizeMemoBodyHtml(body: string): string {
  const raw = String(body ?? '').trim();
  if (!raw) return '';
  if (/<[a-z][\s\S]*>/i.test(raw)) return raw;
  return raw
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map((line) => `<p>${escapeHtml(line) || '<br>'}</p>`)
    .join('');
}

export function emptyMemoBodyHtml(html: string): boolean {
  if (!html.trim()) return true;
  return isMemoBodyEmpty(html);
}

function wrapHtmlFragment(html: string): string {
  return `<!DOCTYPE html><html><body>${html}</body></html>`;
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
